import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgYandexIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 16.186C0 8.644 0 4.872 2.343 2.529S8.458.186 16 .186c7.543 0 11.314 0 13.657 2.343S32 8.644 32 16.186c0 7.543 0 11.314-2.343 13.657S23.543 32.186 16 32.186c-7.542 0-11.314 0-13.657-2.343S0 23.729 0 16.186Z"
      fill="#FC3F1D"
    />
    <path
      d="M21.42 25.702h-3.331V9.212H16.6c-2.723 0-4.148 1.363-4.148 3.395 0 2.305.985 3.373 3.017 4.735l1.676 1.131-4.819 7.229H8.744l4.337-6.453c-2.493-1.781-3.897-3.52-3.897-6.453 0-3.667 2.557-6.16 7.396-6.16h4.82l.02 19.066Z"
      fill="#fff"
    />
  </svg>
);
const Memo = memo(SvgYandexIcon);
export default Memo;
